export {
  SDKEnvironmentTypes,
  SelfieCameraTypes,
  UnicoCheckBuilder,
  UnicoConfig,
  UnicoThemeBuilder,
  LocaleTypes,
} from 'unico-webframe';

// Manter em sincronia com o package.json; ver UNICO_VERSIONS.md para histórico de versões.
export const UNICO_ACTIVE_VERSION = '3.23.7';
